import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import MentionsLegales from "@/pages/MentionsLegales";
import PolitiqueConfidentialite from "@/pages/PolitiqueConfidentialite";
import CGV from "@/pages/CGV";
import QuiSommesNous from "@/pages/QuiSommesNous";
import EtudeSolLaReunion from "@/pages/EtudeSolLaReunion";
import PermisConstruireLaReunion from "@/pages/PermisConstruireLaReunion";
import CommunePage from "@/pages/CommunePage";
import RessourcesPage from "@/pages/RessourcesPage";
import ArticlePage from "@/pages/ArticlePage";
import ExitIntentPopup from "@/components/site/ExitIntentPopup";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/qui-sommes-nous" element={<QuiSommesNous />} />
          <Route path="/etude-de-sol-la-reunion" element={<EtudeSolLaReunion />} />
          <Route path="/permis-de-construire-la-reunion" element={<PermisConstruireLaReunion />} />
          <Route path="/permis-de-construire-saint-denis" element={<CommunePage slug="saint-denis" />} />
          <Route path="/permis-de-construire-saint-pierre" element={<CommunePage slug="saint-pierre" />} />
          <Route path="/permis-de-construire-le-tampon" element={<CommunePage slug="le-tampon" />} />
          <Route path="/permis-de-construire-saint-paul" element={<CommunePage slug="saint-paul" />} />
          <Route path="/permis-de-construire-sainte-marie" element={<CommunePage slug="sainte-marie" />} />
          <Route path="/permis-de-construire-saint-benoit" element={<CommunePage slug="saint-benoit" />} />
          <Route path="/ressources" element={<RessourcesPage />} />
          <Route path="/ressources/:slug" element={<ArticlePage />} />
          <Route path="/mentions-legales" element={<MentionsLegales />} />
          <Route path="/politique-confidentialite" element={<PolitiqueConfidentialite />} />
          <Route path="/cgv" element={<CGV />} />
        </Routes>
        <ExitIntentPopup />
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        richColors
        toastOptions={{
          style: {
            fontFamily: "Manrope, sans-serif",
            borderRadius: 0,
          },
        }}
      />
    </div>
  );
}

export default App;
